import { NgModule }      from '@angular/core';
import { DateParserService } from './dateParser.service';
import { CommonModule } from '@angular/common';
import { LegacyDateParserService } from './legacyDateParser.service';
import { ShortDateParserService } from './shortDateParser.service';

@NgModule({
    imports: [
        CommonModule,
    ],
    providers: [
        DateParserService,
        LegacyDateParserService,
        ShortDateParserService,
    ]
})
export class DateParserModule {  }